import { HttpHeaders } from '@angular/common/http';
import { ISlackAPIConfig } from '../../interfaces/error-handler/slack-error-logger-config.interface';

export const slackErrorLogConfig = (env): ISlackAPIConfig => ({
  logWebhookUrl: env.logging.slack.logWebhookUrl,
  httpHeaders: new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' }),
  pretext: `StemX PublicPage - ${env.type}:v${env.version}`,
});
